import React, { useState, useEffect } from "react";
import Button from "../SelectValue/Button";
import PinInput from "react-pin-input";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Loading from "../SelectValue/Loading";
import postService from "../../Services/post-service";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 430,
  minHeight: 420,
  bgcolor: "white",
  boxShadow: 24,
  borderRadius: "16px",
  p: 4,
  maxWidth: "95%",
  outline: "none",
};

export default function Pin({ open = true, handleClose }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) {
      setPin("");
      setLoading(false);
    }
  }, [open]);

  const bankData = location.state || {};

  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    if (!pin || pin.length < 4) {
      return toast.error("Please enter your 4-digit PIN");
    }
    if (!bankData.accountNumber) {
      toast.error("Missing bank details. Please go back and try again.");
      return;
    }

    setLoading(true);
    postService
      .addBankAcc(
        bankData.bankCode,
        bankData.accountNumber,
        bankData.accountName,
        bankData.bankName,
        pin,
      )
      .then(
        (response) => {
          setLoading(false);
          if (response.data.statusCode === 200) {
            navigate("/bankcards/bankadded");
          } else {
            toast.error(response.data.description);
          }
        },
        (error) => {
          setLoading(false);
          toast.error(error.response?.data?.description);
        },
      );
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={{ ...style, display: "flex", flexDirection: "column" }}>
            <Loading open={loading} />
            <div className="flex justify-end mb-4">
              <Link to="/bankcards">
                <IconButton
                  onClick={handleClose}
                  sx={{
                    bgcolor: "#1F2937",
                    color: "white",
                    "&:hover": { bgcolor: "#374151" },
                    width: 36,
                    height: 36,
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Link>
            </div>

            <div className="mb-8">
              <p className="font-[700] text-[20px] text-back-color2 mb-2">
                Enter your Zouse PIN
              </p>
              <p className="text-[14px] text-gray-500">
                Enter your 4-Digit PIN to add bank
              </p>
            </div>

            <form
              onSubmit={handleSubmit}
              className="flex flex-col flex-1"
            >
              <div className="flex justify-center mb-10">
                <PinInput
                  length={4}
                  initialValue={pin}
                  secret
                  onChange={(value, index) => setPin(value)}
                  type="numeric"
                  inputMode="number"
                  style={{ padding: "10px" }}
                  inputStyle={{
                    borderColor: "#00BC67",
                    backgroundColor: "#FAFBFC",
                    borderRadius: 8,
                    margin: "0 5px",
                    width: "50px",
                    height: "50px",
                    fontSize: "24px",
                    fontWeight: "700"
                  }}
                  inputFocusStyle={{
                    borderColor: "#00BC67",
                    backgroundColor: "#CCF2E1",
                  }}
                  onComplete={(value, index) => setPin(value)}
                  autoSelect={true}
                  regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                />
              </div>
              <button
                type="submit"
                className="mt-auto w-full bg-[#00BC67] text-white font-[700] py-4 rounded-xl transition-colors text-[18px]"
              >
                Submit
              </button>
            </form>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
